import { LegacyBookInitService } from 'modules/shared/legacy-bookexpress/services/legacy-book-initializer.service';
import { BehaviorSubject } from 'rxjs';
import { Keepalive } from '@ng-idle/keepalive';
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root',
})
export class TrackidleService {
  idleState = 'Not started.';
  timedOut = false;
  tenantId: any;
  idleTime: number = 0;
  warningTime: number = 0;
  timerStarted: boolean = false;
  casinoTimeoutRequired: boolean = false;
  propertyId: any;
  lastPing?: Date = null;
  autoLogout = new BehaviorSubject<any>('default');
  timeOuttrigger = new BehaviorSubject<any>('default');
  constructor(
    private idle: Idle,
    private keepalive: Keepalive,
    public MatSnackBar: MatSnackBar,
    public AppInitializer: LegacyBookInitService
  ) {
    this.tenantId = this.AppInitializer.tenantId;
    this.propertyId = this.AppInitializer.propertyId;
    this.casinoTimeoutRequired = this.AppInitializer.PropertyData.hasCasinoTimeout;
    this.idleTime = Number(this.AppInitializer.PropertyData.idleTime) || 30;
    this.warningTime = Number(this.AppInitializer.PropertyData.warningTime) || 10;
    idle.setIdle(this.idleTime);
    idle.setTimeout(this.warningTime);
    idle.setIdleName(this.tenantId + '-' + this.propertyId);
    idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);
    idle.onIdleEnd.subscribe(() => {
      this.timeOuttrigger.next('action');
    });
    idle.onTimeout.subscribe(() => {
      console.log('timeout');
      this.idleState = 'Timed out!';
      this.timedOut = true;
      //  this.autoLogout.next('logout');
    });
    idle.onIdleStart.subscribe(() => {});
    idle.onTimeoutWarning.subscribe((countdown: any) => {
      this.timeOuttrigger.next(countdown);
    });
  }
  start() {
    if (this.casinoTimeoutRequired) {
      this.timerStarted = true;
      this.idle.watch();
      console.log('Started');
      this.timedOut = false;
    }
  }
  stop() {
    if (this.casinoTimeoutRequired) {
      this.timerStarted = false;
      this.timedOut = true;
      this.idle.stop();
      console.log('stopped');
    }
  }
}
